// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  syncfusionLicenseKey : "ORg4AjUWIQA/Gnt2VVhkQlFadVdJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRd0dhW35WcHFVRWRUVEI=",
  //WP CONFIGURATION
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
  activeProjectCookieKey : "ACTIVE_PROJECT_ID",
  backendUri: 'https://msdev.moonflow.xyz/backoffice-api-front',
  frontUri: 'https://dashboarddev.moonflow.xyz',
  backofficeCookieKey : "BACKOFFICE_API_COOKIE",
  backofficeProjectCookieKey : "BACKOFFICE_API_PROJECT_COOKIE",
  refreshJwtHeader : "REFRESH_JWT",
  refreshProjectHeader : "BACKOFFICE_API_PROJECT_REFRESH",
  //END WP CONFIGURATION
  appVersion: 'v8.0.27',
  USERDATA_KEY: 'authf649fc9a5f55',
  isMockEnabled: true,
  apiUrl: 'api',
  API_URL: 'https://msdev.moonflow.xyz/backoffice-api',
  googleKey : "AIzaSyBiW3Rd88vLnQCYEgdY2-8tX0h6pClTqSY",
  googleFontsUrl : "https://msdev.moonflow.xyz/backoffice-api/moonflowutils/fonts?key=",
  appThemeName: 'Metronic',
  appPurchaseUrl: 'https://1.envato.market/EA4JP',
  appHTMLIntegration: 'https://preview.keenthemes.com/metronic8/demo1/documentation/base/helpers/flex-layouts.html',
  appPreviewUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1/',
  appPreviewAngularUrl: 'https://preview.keenthemes.com/metronic8/angular/demo1',
  appPreviewDocsUrl: 'https://preview.keenthemes.com/metronic8/angular/docs',
  appPreviewChangelogUrl: 'https://preview.keenthemes.com/metronic8/angular/docs/changelog',
  webFormDomain : ".moonflow.xyz",
  refreshTokenLocalstorageKeys : "P73nl_,_zaSyCF,_ZOPe,_75eoPas",
  aesSecretKey: '4HgHJK1robDvWGqI6AW6GX6q4sQRTUFApIrZVHAm1UEKHdRiTmA0YBOPcAp9OWuYU',
  websocket: '7wNf2Kp9Qx4Vm8Hs3Ld6Rc1Tg5Yb0ZaUe7Ji2On9Fs4Cx8Mv',
  googleClientId : '788317176686-h9utsqv4islv11uv6lb3a77nialqpopg.apps.googleusercontent.com',
  microsoftClientId : 'fda999e8-42c7-4ef4-84f1-67ca40c6e4b3',
  websocketServerUrl : "wss://websocketdev.moonflow.xyz/websocket",
  siteKey : "6LcRdHUnAAAAAPAE0GS7_a3VUF4BDTH8vHSOL-Jl",
  stripeAutomaticRechargePriceIdDefault : 1,
  userProjectPageConfigurationKey : "bbx2xJgtL6G5bYILpEEE",
  userProjectReportConfigurationKey : "d2rX5MbcwFxIvs2EtMcM",
  appIdFacebook : "1125040289365019",
  configIdFacebook: "620992107527087",
  moonflowTalkDashboardTextId: 12,
  moonflowTalkDashboardVoiceId: 14,
  // apiUrl: 'mysite.com/api',
  urlBaseWebFormRecovery : "/recovery",
  urlVozyTestCalls : 'https://warmi-payment-public-stg.s3.us-east-1.amazonaws.com/vozy-test-calls'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
